import { Button } from '@mui/material'
import { useTranslate } from 'ra-core'
import { useState } from 'react'
import { Confirm, Toolbar, SaveButton, CREATE, useRecordContext } from 'react-admin'
import { useFormState } from 'react-hook-form'

import { useCommonStyles } from '../config/theme'
import { useDraftKey } from '../resources/common/FormDraft'
import { useHandleRedirection } from '../resources/common/hooks'
import { removeFormDraft } from '../utils/formDrafts'

const useCloseForm = () => {
  const handleRedirection = useHandleRedirection()
  const record = useRecordContext()

  return async () => {
    const closeButton = document.querySelector('.RaFormDialogTitle-closeButton')
    if (closeButton) {
      closeButton.click()
    } else {
      await handleRedirection(record)
    }
  }
}

const CancelButton = () => {
  const closeForm = useCloseForm()
  const translate = useTranslate()

  return (
    <Button variant="outlined" onClick={closeForm}>
      {translate('ra.action.cancel')}
    </Button>
  )
}

const DraftCancelButton = () => {
  const { isDirty } = useFormState()
  const draftKey = useDraftKey()
  const closeForm = useCloseForm()
  const translate = useTranslate()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const discard = async () => {
    setIsConfirmOpen(false)
    if (draftKey) removeFormDraft(draftKey)
    await closeForm()
  }

  return (
    <>
      <Button variant="outlined" onClick={() => (isDirty ? setIsConfirmOpen(true) : closeForm())}>
        {translate('ra.action.cancel')}
      </Button>
      <Confirm
        isOpen={isConfirmOpen}
        title="mymove.discardDraft.title"
        content="mymove.discardDraft.content"
        confirm="mymove.discardDraft.confirm"
        onConfirm={discard}
        onClose={() => setIsConfirmOpen(false)}
      />
    </>
  )
}

const BasicFormToolbar = ({ alwaysEnableSaveButton, formType = CREATE, draftable = false }) => {
  const classes = useCommonStyles()
  return (
    <Toolbar sx={classes.toolbar}>
      <SaveButton alwaysEnable={formType === CREATE || alwaysEnableSaveButton} />
      {draftable ? <DraftCancelButton /> : <CancelButton />}
    </Toolbar>
  )
}

export default BasicFormToolbar
